
const HowUscyWorksPage = () => {
  return (
    <section>
      <p>
        A Full System Overview: Minting, Vaults, Rewards, Queue, Redemption &
        YPP USCY is an institutional-grade, 1:1 redeemable USD stablecoin
        designed to maintain economic continuity for the original depositor,
        independent of how the token is used operationally. The key to this
        architecture is the separation between: USCY tokens, which move freely
        through trading, settlement, treasury, and custody workflows Collateral
        vaults, which store principal and determine the depositor’s rewards
        until redemption This page explains how the entire system works
        end-to-end. 1. The Core Principle: Tokens Move, Vaults Earn Traditional
        stablecoins break the link between depositors and yield: once the token
        is transferred, the depositor loses all economic benefit. USCY reverses
        this: The depositor keeps their economic rights until their vault is
        closed. The token remains a simple, clean, 1:1 transferable instrument.
        This model ensures: Yield continuity throughout the vault’s lifetime No
        exposure of yield to token holders No change to regulatory status of
        USCY Full compatibility with trading, OES, and treasury workflows
        Everything begins with the minting process. 2. Minting USCY: How a New
        Vault Is Created When an eligible, fully onboarded customer mints USCY:
        Customer deposits USD → Held in the USCY Reserves Trust → Custodied by
        Northern Trust USCY tokens are minted 1:1 by the regulated issuer
        (Brale) A new collateral vault is created Contains the deposited
        principal Has its own vault ID Records creation timestamp Begins
        accruing rewards immediately Joins the front of the queue (LIFO) Starts
        with temporary protection to prevent immediate closure The customer now
        has both: USCY tokens (free to use operationally) A vault that tracks
        their economic rights This separation is fundamental to the USCY model.
        3. Collateral Vaults: The Source of Rewards Each vault holds: USD
        principal Accrued rewards during its lifetime A history of YPP
        allocations A definitive time created Rewards continue only while a
        vault remains open. They do not follow the USCY tokens. Why? Because
        rewards attach to original deposits, not token balances. This aligns
        fully with GENIUS-compliant principles: The yield belongs to the
        depositor Tokens remain non-yield-bearing No implicit dividend or return
        is attached to token ownership Vaults exist until they reach the front
        of the redemption queue. 4. The Redemption Queue: How Vaults Progress
        Over Time All open vaults sit in a single, global, ordered queue. Queue
        bands: Front → closest to closure Middle → neutral region Rear → longest
        remaining duration Default behaviour: New vaults always enter at the
        front Temporary protection prevents immediate closure Vaults gradually
        move through the queue depending on: Redemptions New mints Market
        expansion or contraction YPP allocations The queue is how the system
        determines when rewards end. 5. How Queue Drift Works A vault moves in
        the queue depending on the net balance of mints versus redemptions. A.
        Contraction (more redemptions than mints) Vaults move toward the front
        Yield horizons shorten Duration risk increases Many vault owners
        allocate YPPs to maintain position B. Expansion (more mints than
        redemptions) New vaults continuously join at the front Older vaults
        naturally drift toward the rear Rewards windows naturally extend C. YPP
        overrides Vault owners can override natural movement by spending YPPs to
        reposition vaults at any time. This creates a market-based duration
        mechanism, not a yield mechanism. 6. Redemption: How Vaults Close When a
        customer redeems USCY at par: Redemption request is validated USCY
        tokens are burned The vault at the front of the queue is closed USD
        principal is released to the redeemer The closed vault’s yield window
        ends The vault is removed from the queue permanently Important points:
        The redeemer does not need to be the same customer that owned the vault
        Vault closure depends only on ranking, not ownership Vault owners know
        the mechanics in advance and can adjust using YPPs Redemption is always
        at par, fully backed, subject to eligibility and programme terms This
        preserves USCY’s regulatory simplicity and guarantees predictability. 7.
        How Duration Is Managed With YPPs Yield Protection Points (YPPs) allow
        vault owners to influence how long their vaults remain active before
        closure. YPPs allow vault owners to: Move a vault further back in the
        queue Extend its reward horizon Offset contraction-driven drift Protect
        high-value or strategic vaults Harmonise vault duration with operational
        cycles (e.g., OES flows) YPPs do not: Increase the yield rate Provide
        additional yield Change redemption rights Modify the stablecoin’s
        regulatory category Affect the peg Give governance or financial rights
        YPPs change timing, not value. 8. The User Experience: What Institutions
        See A. Collateral Positions Dashboard For each open vault, institutions
        see: Queue band (Front / Middle / Rear) Precise ranking Rewards earned
        so far YPPs applied to that vault Closed vaults are not shown. B. YPP
        Spend Flow During a YPP spend action, the platform displays: Current
        ranking Proposed ranking after spend Resulting band This visual preview
        is essential for risk and treasury planning. C. APIs for algorithmic
        vault management Institutions can integrate: Retrieve open vaults +
        ranking Estimate ranking after YPP spend Mint / redeem programmatically
        This supports automated strategies in market making, OES, and treasury
        environments. 9. The Lifecycle of a Vault A vault goes through three
        phases: 1. Open Phase Created from a mint Temporarily protected Accrues
        rewards Moves naturally through the queue Can be repositioned via YPPs
        2. Closure Phase Triggered by redemption: Vault at the front is closed
        Rewards cease Vault leaves the queue 3. Final State Vault cannot reopen
        Economic rights associated with that deposit end This lifecycle is
        simple, transparent, predictable, and rule-based. 10. Why the USCY Model
        Works for Institutions USCY offers institutions a structural advantage
        over existing stablecoins: A. Rewards continuity even in high-velocity
        flows Rewards do not depend on token balances. OES activity, trading
        rotations, or treasury operations do not break the depositor’s
        economics. B. Market-based duration control YPPs allow precise
        management of vault duration without changing: Yield rate Token
        characteristics Redemption conditions Regulatory categorisation C.
        Bankruptcy-remote, trust-based reserves USD held in the USCY Reserves
        Trust Custodied by Northern Trust Issued by a regulated US MSB (Brale)
        No commingling with issuer assets D. Predictability The queue provides a
        transparent, rule-based mechanism for determining when reward accrual
        ends. E. Interoperability USCY works seamlessly in: Off-exchange
        settlement (OES) Trading venues Custodial ecosystems Treasury automation
        Payments Prime workflows F. Regulatory clarity The depositor earns
        rewards through a vault-based structure fully aligned with GENIUS-style
        policy principles, while the stablecoin itself remains clean and
        non-yield-bearing. 11. Summary USCY operates through a clean separation:
        USCY tokens → 1:1 transferable cash instrument Vaults → containers of
        economic rights Queue → determines when vaults stop earning YPPs →
        optionality over duration, but not yield In combination, this
        architecture delivers: Institutional-grade stability, economic integrity
        for depositors, and full operational flexibility for token holders.
      </p>
    </section>
  )
}

export default HowUscyWorksPage